import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";
import { toast } from 'vue3-toastify';
import { h } from "vue";
export default {
  name: "alerts",
  computed: {
    ...mapGetters({
      alerts: 'app/alerts'
    })
  },
  data: function () {
    return {
      sweetAlert: Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        background: '#fff'
      })
    };
  },
  methods: {
    icon: function (text) {
      let path = null;
      switch (text) {
        case 'info':
          path = "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z";
          break;
        case 'success':
          path = "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z";
          break;
        case 'error':
        case 'danger':
          path = "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z";
          break;
        case 'warning':
          path = "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z";
          break;
      }
      if (path) {
        return h("svg", {
          viewBox: "0 0 24 24",
          width: "100%",
          height: "100%",
          style: "fill: currentColor"
        }, [h("path", {
          d: path
        })]);
      }
      return null;
    },
    alert(message, variant, icon = 'info', timer = 2500) {
      // vue3-toastify types are success|info|warning|error|default — NOT the
      // bootstrap variant names. 'danger' has no colored-theme background rule,
      // so it renders transparent (only the shadow). Map variants to toast types.
      const typeMap = {
        success: 'success',
        info: 'info',
        warning: 'warning',
        danger: 'error',
        error: 'error'
      };
      const options = {
        theme: 'colored',
        autoClose: timer,
        position: "top-right",
        type: typeMap[variant] || 'default'
      };
      let svgIcon = this.icon(icon);
      if (svgIcon) {
        options.icon = svgIcon;
      }
      toast(message, options);

      /*this.sweetAlert.fire({
          icon: icon,
          title: message,
          timer: timer,
          customClass: {
              popup: ' bg-soft-' + variant,
              title: 'text-' + variant,
              cancelButton: 'btn btn-primary btn-md ms-1',
              header: 'bg-' + variant,
              icon: 'text-' + variant + ' border-' + variant
          },
      });*/
    }
  },
  watch: {
    'alerts': function (val, oldVal) {
      const length = val.length,
        oldLength = oldVal.length;
      if (length > oldLength) {
        val.slice(length - (length - oldLength)).forEach(item => {
          this.alert(item.message, item.style, item.icon, item.countdown);
        });
      }
    }
  },
  render: function () {
    return ``;
  }
};